let audio = null; // Declare a persistent audio object

export const video_modal = (data) => {
    AudioPlayer(data)
    return ({ type: 'VIDEO_MODAL', data: { video_modal: data } })
};
export const audio_modal = (data) => {
    AudioPlayer(data)
    return ({ type: 'AUDIO_MODAL', data: { audio_modal: data } })
};

const AudioPlayer = (data) => {

    if (!audio) {
        audio = new Audio("/assets/img/ringtone-1-275863.mp3");
        audio.loop = true; // Set the audio to loop infinitely
    }

    if (data) {
        audio.play().catch((error) => {
            console.error("Error playing audio:", error);
        });
    } else {
        audio.pause();
        audio.currentTime = 0; // Reset the audio to the beginning
    }
};